var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#6474E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 32.5C13.0365 32.5 12.6719 32.1094 12.6719 31.3281V11.2656C12.6719 10.4844 13.0365 10.0938 13.7656 10.0938H19.2188C24.0104 10.0938 27.25 11.0625 28.9375 13C30.6354 14.9375 31.4844 17.6927 31.4844 21.2656C31.4844 24.8385 30.6354 27.6042 28.9375 29.5625C27.25 31.5208 24.0104 32.5 19.2188 32.5H13.7656ZM17.2344 28.625H18.9219C22.151 28.625 24.2396 28.026 25.1875 26.8281C26.1354 25.6198 26.6094 23.7656 26.6094 21.2656C26.6094 18.7656 26.1354 16.9219 25.1875 15.7344C24.2396 14.5365 22.151 13.9375 18.9219 13.9375H17.2344V28.625Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 30,
    r: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eea4a05f0ec6f4548a34c90ef491ddc0.svg";
export { ForwardRef as ReactComponent };